import DaisyBaseService from './DaisyBaseService';

/**
 * this is the authentification service which handle the communication with the daisy backend
 **/
export default class AuthService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.baseUrl = this.baseUrl + 'Login';
		this.$storage = $injector.get('$sessionStorage');
		
		this.loggedIn = !!this.$storage.auth;
	}

	/**
	 * load all plants
	 * @return {promise} with all plants for the company
	 **/
	getPlants(){
		let functionUrl = '/GetPlants';
		let data = {};

		return this.doPost(functionUrl, data, {ignoreLoadingIndicator:true});
	}

	/**
	 * load all plants for current user
	 * @param {string} userName - user name to get the plants for
	 * @return {promise} with all for current user
	 * @todo use the doPost method from the superclass
	 **/
	getUserPlant(userName){
		let functionUrl = '/GetUserPlant';
		let data = {
			'USER_NAME': userName
		};

		return this.doPost(functionUrl, data);
	}

	/**
	 * log the user in
	 * @param {string} username - username
	 * @param {number} password - password
	 * @param {number} plantId - plant id
	 * @return {promise} with the current user
	 **/
	login(username, password, plantId){
		let functionUrl = '/Login';
		let data = {
			'LOGIN_DATA': {
				'LOGIN_NAME': '',
				'PASSWORT': '',
				'PERS_NR': username,
				'PIN': parseInt(password),
				'EVENT_NAME': this.eventName,
				'PLANT_ID': parseInt(plantId)
			}
		};

		return this.doPost(functionUrl, data);
	}

	/**
	 * log the user out and delete the auth object inside the localStorage
	 * @return {promise} with true/false
	 **/
	logout() {
		this.loggedIn = false;
		delete this.$storage.auth;
		return this.$q.resolve(true);
	}

	/**
	 * check if the user is authenticated
	 * @return {promise} with true/false
	 **/
	isAuthenticated() {
		return this.$q.resolve(!!this.$storage.auth);
		// return this.$q.resolve(this.loggedIn);
	}
}
